import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { AppLayoutDahboardWithNav } from '@/modules/shared/layouts/AppLayoutDahboardWithNav'
import { toRelativeRoute, wrapRoutesWithRouter } from '@/modules/shared/utils/routerPaths'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const wrappedAddCompanyRoutes = wrapRoutesWithRouter(addCompanyRoutes)
import { addCompanyRoutes } from './routes'
import { addCompanyPath } from './index'
import { AddCompanyLayout } from './AddCompanyLayout'

const AddCompanyModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
          <AppLayoutDahboardWithNav>
            <PermissionGuard companyId={companyId} {...moduleAccess.addCompany}>
              <AddCompanyLayout companyId={companyId!}>
                <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
                  <Routes>
                    {wrappedAddCompanyRoutes.map((route) => (
                          <Route
                          key={route.path}
                          path={`${toRelativeRoute(route.path, addCompanyPath)}/*`}
                          element={<route.Component />}
                        />
                        ))}

                    {/* fallback */}
                    <Route
                      path="*"
                      element={<div>Add Company Module - Select a view</div>}
                    />
                  </Routes>
                </ErrorBoundary>
              </AddCompanyLayout>
            </PermissionGuard>
          </AppLayoutDahboardWithNav>
    </ErrorBoundary>
  )
}

export const AddCompanyModule = AddCompanyModuleImpl
